(function() {
  'use strict';

  var ScreeningCaseInternationalChecksCtrl = function ($http, $scope, $uibModalInstance, $window, ajaxCall, $sce, passedModel,xmsNotificationFactory) {

    if( !angular.isDefined(passedModel) ){
      passedModel = {}; // otherwise any ng-init inside modal will create the model in its own child scope (inaccessible)
    }

    console.log("INSIDE ScreeningCaseInternationalChecksCtrl");
    $scope.internationalCheckModel = passedModel;

    if($scope.internationalCheckModel.actionType == 'create') {
      $scope.internationalCheckModel.countryLookupValId = '';
      $scope.internationalCheckModel.checkTypeLookupValId = '';
      $scope.internationalCheckModel.supplier = '';
      $scope.internationalCheckModel.statusLookupValId = '';
      $scope.internationalCheckModel.dateRequested = '';
      $scope.internationalCheckModel.dateReturned = '';
      $scope.internationalCheckModel.thirdPartyFee = '';
      $scope.internationalCheckModel.unitFee = '';
      $scope.internationalCheckModel.slaDate = '';
    }

    $scope.internationalCheckModel.disableSubmit = false;

    $scope.submitForm = function ($event) {
      console.log("INSIDE submitForm");
      $scope.internationalCheckModel.disableSubmit = true;

      $event.preventDefault();

      var ajaxUrl = WEBAPP_PATH + "/screeningCaseInternationalChecks/save";

      var fd = new FormData();

      var ajaxData = $('#intCheckPopupForm').serializeArray();

      $.each(ajaxData, function (key, input) { // please use angular.forEach function instead $.each
        fd.append(input.name, input.value);
        // the above should be done by ng-repeat in your template, so probably you may not need the whole thing in here...
      });

      $http({
        method: "post",
        url: ajaxUrl,
        data: fd,
        headers: {'Content-Type': undefined},
        transformRequest: angular.identity
      }).then(function (response) {
        $scope.internationalCheckModel.smartTableRefreshCounter++;
        console.log(response.data);
        xmsNotificationFactory.addObj({id: "saveIntCheck", type: response.data.responseType, bodyHtml: response.data.responseMessage, timeout: 10});
        $uibModalInstance.close($scope.internationalCheckModel);
      });
    }


    $scope.updateForm = function ($event) {
      console.log("INSIDE updateForm");
      console.log("$scope.internationalCheckModel.smartTableRefreshCounter");
      console.log($scope.internationalCheckModel.smartTableRefreshCounter);
      $scope.internationalCheckModel.disableSubmit = true;
      $event.preventDefault();

      var ajaxUrl = WEBAPP_PATH + "/screeningCaseInternationalChecks/update";

      var fd = new FormData();

      var ajaxData = $('#intCheckPopupForm').serializeArray();
      $.each(ajaxData, function (key, input) {
        fd.append(input.name, input.value);
      });
      $http({
        method: "post",
        url: ajaxUrl,
        data: fd,
        headers: {'Content-Type': undefined},
        transformRequest: angular.identity
      }).then(
        function (response) {
          $scope.internationalCheckModel.smartTableRefreshCounter++;
          console.log(response.data);
          xmsNotificationFactory.addObj({id: "updateIntCheck", type: response.data.responseType, bodyHtml: response.data.responseMessage, timeout: 10});
          $uibModalInstance.close($scope.internationalCheckModel);
        });
    }

    $scope.cancel = function(e) {
      if(angular.isDefined(e)){
        e.preventDefault();
      }
      $uibModalInstance.dismiss('cancel');
    };

  }
  ScreeningCaseInternationalChecksCtrl.$inject = ['$http','$scope','$uibModalInstance','$window','ajaxCall', '$sce', 'params','xmsNotificationFactory'];
  angular.module('app').controller('ScreeningCaseInternationalChecksCtrl', ScreeningCaseInternationalChecksCtrl);

}());
